let app = {};
let extraStatusForSidebar = [
    { color: 'blue', id: '', label: 'All Shirt', keyword: 'all_shirt', sorter: 0 },
    { color: 'red', id: 'waiting', label: 'Waiting', keyword: 'waiting', sorter: 21 },
    { color: 'red', id: 'urgent', label: 'Urgent', keyword: 'urgent', sorter: 22 },
    { color: 'red', id: 'repair', label: 'Repair', keyword: 'repair', sorter: 23 },
]
app.getStatuses = () => {
    return new Promise(async (resolve, reject) => {
        try {
            let res = await axios.get('shirt_orders/shirt_order_statuses');
            if (res) {
                let statuses = res.data.map(status => {
                    let tmp = {
                        label: status.title,
                        keyword: status.keyword,
                        id: status.id,
                        color: status.theme_color,
                        sorter: status.sorter,
                    }
                    return tmp;
                });
                statuses.unshift()
                extraStatusForSidebar.forEach(val => {
                    statuses.push(val);
                })
                resolve(statuses);
            }
        }
        catch (error) {
            reject(error);
        }
    })

}

export default app;
